"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dashboard = void 0;
const attributionMetrics_1 = require("./attributionMetrics");
const conversionMetrics_1 = require("./conversionMetrics");
const dimensions_1 = require("./dimensions");
const chart_1 = require("./queries/chart");
const conversionsList_1 = require("./queries/conversionsList");
const dimensionsWithValuesList_1 = require("./queries/dimensionsWithValuesList");
const table_1 = require("./queries/table");
exports.dashboard = {
    attributionMetrics: attributionMetrics_1.attributionMetrics,
    conversionMetrics: conversionMetrics_1.conversionMetrics,
    dimensions: dimensions_1.dimensions,
    conversionsList: {
        name: 'Conversions',
        query: conversionsList_1.conversionsList,
    },
    dashboardTable: {
        name: 'Dashboard table',
        query: table_1.dashboardTable,
    },
    dashboardChart: {
        name: 'Dashboard chart',
        query: chart_1.dashboardChart,
    },
    dimensionsWithValuesList: {
        name: 'Dimensions with values',
        query: dimensionsWithValuesList_1.dimensionsWithValuesList,
    },
};
//# sourceMappingURL=index.js.map